import { render } from "./OLoadingSmall.vue?vue&type=template&id=7661aa23&scoped=true"
import script from "./OLoadingSmall.vue?vue&type=script&lang=js"
export * from "./OLoadingSmall.vue?vue&type=script&lang=js"

import "./OLoadingSmall.vue?vue&type=style&index=0&id=7661aa23&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7661aa23"]])

export default __exports__